"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationPreferences = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NotificationPreferencesGroup = require("./NotificationPreferencesGroup");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NotificationPreferences = function NotificationPreferences(_ref) {
  var preferences = _ref.preferences,
    loading = _ref.loading,
    phoneChangeDescription = _ref.phoneChangeDescription,
    phoneChangeCta = _ref.phoneChangeCta,
    onPhoneChange = _ref.onPhoneChange;
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    size: "large",
    spinning: loading || !preferences
  }, preferences === null || preferences === void 0 ? void 0 : preferences.map(function (_ref2) {
    var items = _ref2.items,
      name = _ref2.name,
      note = _ref2.note,
      title = _ref2.title,
      restrictions = _ref2.restrictions;
    return /*#__PURE__*/_react.default.createElement(_NotificationPreferencesGroup.NotificationPreferencesGroup, {
      key: name,
      items: items,
      note: note,
      title: title,
      restrictions: restrictions,
      phoneChangeDescription: phoneChangeDescription,
      phoneChangeCta: phoneChangeCta,
      onPhoneChange: onPhoneChange
    });
  }));
};
exports.NotificationPreferences = NotificationPreferences;
NotificationPreferences.propTypes = {
  /**
   * Text shown in Tooltip prompting user to add phone number
   */
  phoneChangeDescription: _propTypes.default.string.isRequired,
  /**
   * Button label in Tooltip
   */
  phoneChangeCta: _propTypes.default.string.isRequired,
  onPhoneChange: _propTypes.default.func.isRequired
};